<!--
 * @Description:
 * @Author: rqcheng
 * @Date: 2022-06-09 12:45:36
 * @LastEditTime: 2025-06-20 16:07:29
 * @LastEditors: rqcheng
-->
<template>
  <Nav class="horizontal-nav">
    <nav class="flex" :style="{ backgroundColor: bgcolor }">
      <slot name="left"> </slot>
      <ul class="nav flex" :style="{ 'max-width': maxWidth + 'px' }">
        <li v-for="(item, index) in data" :key="index" @click="navto(item)">
          <div :class="{ active: route_id == item.id }" class="nav-item hover">
            <span>{{ item.label }}</span>
          </div>
          <!-- <router-link :to="{name:item.name,query:{id:item.id}}" >
          </router-link> -->
        </li>
      </ul>
      <slot name="right"></slot>
    </nav>
  </Nav>
</template>
<script>
import Nav from "./Nav";
export default {
  name: "HorizontalNav",
  components: {
    Nav
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    maxWidth: {
      type: Number,
      default: () => 1200
    },
    bgcolor: {
      type: String,
      default: () => "#2f3237"
    }
  },
  computed: {
    route_id() {
      return this.$route.query.id;
    }
  },
  data() {
    return {
      arr: []
    };
  },
  methods: {
    navto(item) {
      if (this.route_id == item.id) {
        return;
      }
      this.$emit("navto", item);
      return false;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../common/css/variable.less);
.horizontal-nav {
  background-color: #293042;
  color: #fff;
  nav {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 15px;
    .nav {
      justify-content: space-between;
      align-items: center;
      flex: 1 1 auto;
      flex-wrap: wrap;
      a {
        line-height: 60px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #d8f0ff;
        text-shadow: 0px 0px 10px #0091ff;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
      .nav-item {
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        // padding: 0.18rem;
        padding: 12px;
        transition: background-color 0.3s ease-in 0s, color 0.5s ease-in-out 0s;
        &.active,
        &:hover {
          background: linear-gradient(
            180deg,
            rgba(15, 74, 159, 0) 0%,
            rgba(17, 75, 160, 0.95) 100%
          );
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/HorizontalNav.vue